import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from '@app/services/menu';
import { ResourceLibraryService } from '@app/services/resource-library/resource-library.service';
import { ProjectService } from '@app/services/project/project.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {

	private subscription = new Subscription();
	imageUrl: string;

	constructor(
			private menuService: MenuService,
			private resourceLibraryService: ResourceLibraryService,
			private projectService: ProjectService,
	) {}

	ngOnInit(): void {
		this.subscription.add(this.projectService.activeProject$.subscribe(project => {
			if (project?.welcomeConfig) {
				this.menuService.title = project.welcomeConfig.message;
				if (project.welcomeConfig.welcomeImage) {
					this.imageUrl = this.resourceLibraryService.resolveUrl(`res:${project.welcomeConfig.welcomeImage}`);
				}
			} else {
				this.menuService.title = 'misc.welcome';
				this.imageUrl = undefined;
			}
		}
		));

	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}
